/**
 * Phase 5: Web Vitals Real User Monitoring (RUM)
 * Captures LCP, FID, CLS, INP, FCP, TTFB from real users
 * and sends them to Google Analytics 4 (if available)
 * or stores them in a lightweight beacon endpoint.
 *
 * Uses the web-vitals library (loaded from CDN) for accurate measurement.
 * Only runs on 25% of page loads to minimize overhead.
 */
(function () {
  'use strict';

  // Sample rate: only measure on 25% of visits to reduce overhead
  if (Math.random() > 0.25) return;

  // Dynamically load web-vitals library (v4, ~2KB gzipped)
  // SRI hash ensures the CDN file hasn't been tampered with
  var script = document.createElement('script');
  script.src = 'https://unpkg.com/web-vitals@4/dist/web-vitals.iife.js';
  script.integrity = 'sha384-1PI/OUsSQhxr4DFizutzo+KWo8Q0eSCQGQLaqeWQVYveFFPV4SCWGl3HoB0d07B4';
  script.crossOrigin = 'anonymous';
  script.async = true;
  script.onload = function () {
    if (!window.webVitals) return;

    var reported = {};

    function sendToAnalytics(metric) {
      // Prevent duplicate reports
      if (reported[metric.name]) return;
      reported[metric.name] = true;

      var data = {
        name: metric.name,
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        rating: metric.rating, // 'good', 'needs-improvement', or 'poor'
        delta: Math.round(metric.name === 'CLS' ? metric.delta * 1000 : metric.delta),
        id: metric.id,
        page: window.location.pathname,
        device: window.innerWidth < 768 ? 'mobile' : 'desktop'
      };

      // Method 1: Send to Google Analytics 4 via gtag
      if (typeof gtag === 'function') {
        gtag('event', 'web_vitals', {
          event_category: 'Web Vitals',
          event_label: data.name,
          value: data.value,
          metric_rating: data.rating,
          metric_delta: data.delta,
          metric_id: data.id,
          page_path: data.page,
          device_type: data.device,
          non_interaction: true
        });
      }

      // Method 2: Send to GA4 via dataLayer (for GTM setups)
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'web_vitals',
          webVitalName: data.name,
          webVitalValue: data.value,
          webVitalRating: data.rating,
          webVitalDelta: data.delta,
          webVitalPage: data.page,
          webVitalDevice: data.device
        });
      }

      // Method 3: Console log in development (remove in production if desired)
      if (window.location.hostname === 'localhost' || window.location.search.indexOf('debug_vitals') > -1) {
        console.log('[Web Vitals]', data.name, data.value, '(' + data.rating + ')');
      }
    }

    // Register all Core Web Vitals observers
    webVitals.onLCP(sendToAnalytics);
    webVitals.onFID(sendToAnalytics);
    webVitals.onCLS(sendToAnalytics);
    webVitals.onINP(sendToAnalytics);
    webVitals.onFCP(sendToAnalytics);
    webVitals.onTTFB(sendToAnalytics);
  };

  document.head.appendChild(script);
})();
